import { createComponent } from '@carvana/merch-components';
import Close from '~/icons/Close';

export const Wrapper = createComponent('div', {
  className:
    'fixed inset-0 m-auto flex items-center justify-center bg-blue-6 bg-opacity-30 m:pr-[var(--scrollbar-width)] m:pt-0'
});

export const Content = createComponent('div', {
  className:
    'relative z-30 m-0 flex h-full w-full max-w-[768px] flex-1 flex-col self-center m:h-auto m:max-h-[95vh] m:max-w-[700px] m:rounded'
});

const HeaderContainer = createComponent('div', {
  className: 'w-full bg-white px-0 py-16 text-blue-6 shadow-md-legacy'
});

export const MobileHeaderContainer = createComponent(HeaderContainer, {
  className: 'fixed left-0 top-0'
});

export const DesktopHeaderContainer = createComponent(HeaderContainer, {
  className: 'relative rounded'
});

export const ModalHeader = createComponent('h5', {
  className: 'm-0 text-center tl-label-m m:tl-label-l'
});

export const CloseIcon = createComponent(Close, {
  className: 'absolute inset-y-0 right-[14px] m-auto'
});
